module.exports = "/images/vendor/flag-icon-css/flags/4x3/vc.svg?4ac5124fbf60fcff6808515904a79f04";